import React from "react";
import { Route } from "react-router-dom";

import AlertList from "cortex/ui/src/fleet/view/alert/component/AlertList";
import EventsList from "cortex/ui/src/fleet/view/event/component/EventsList";
import IncidentsList from "cortex/ui/src/fleet/view/incidents/IncidentsList";
import UptimeDeviceReport from "cortex/ui/src/fleet/view/report/component/UptimeDeviceReport";
import UptimeDevicesReport from "cortex/ui/src/fleet/view/report/component/UptimeDevicesReport";
import UptimeReport from "cortex/ui/src/fleet/view/report/component/UptimeReport";

function renderDiagnosticRoutes() {
  return [
    <Route
      component={EventsList}
      exact
      key="diagnostics-event"
      path="/diagnostics"
    />,
    <Route
      component={IncidentsList}
      exact
      key="diagnostics-incidents"
      path={["/diagnostics/incidents", `/diagnostics/incidents/:incidentId`]}
    />,
    <Route
      component={AlertList}
      exact
      key="alert-list"
      path={[
        "/diagnostics/alerts",
        `/diagnostics/alerts/:action(create)`,
        `/diagnostics/alerts/:id/:action(edit)`,
      ]}
    />,
    <Route
      component={UptimeReport}
      exact
      key="diagnostics-uptime-network"
      path={[
        "/diagnostics/uptime-report",
        "/diagnostics/uptime-report/:networkId/:start/:end",
      ]}
    />,
    <Route
      component={UptimeDevicesReport}
      exact
      key="diagnostics-uptime-network-date"
      path="/diagnostics/uptime-report/:networkId/:start/:end/devices/:date"
    />,
    <Route
      component={UptimeDeviceReport}
      exact
      key="diagnostics-uptime-network-device"
      path="/diagnostics/uptime-report/:networkId/:start/:end/device/:deviceId"
    />,
  ];
}

export { renderDiagnosticRoutes };
